import { render, staticRenderFns } from "./SearchStudentCourse.vue?vue&type=template&id=414c1aee&scoped=true"
import script from "./SearchStudentCourse.vue?vue&type=script&lang=js"
export * from "./SearchStudentCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c1aee",
  null
  
)

export default component.exports